export default __webpack_public_path__ + "static/media/Tibaldi.5d951b49.png";